import React, {Fragment} from 'react';

import {TouchableOpacity, View} from 'react-native';
import {BodyText} from '../../CommonView/Text';
import EntypoIcon from 'react-native-vector-icons/Entypo';
import useParams from '../../../Hooks/useParams';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {Camera} from 'expo-camera';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

const CameraControlRow = ({
  toggleCamera,
  handleCapture,
  loading,
  type,
  toggleFlash,
  reverseState,
  flash,
  isRecording,
  handleCameraRoll,
  showSave = false,
  handleRetake,
  handleSubmitChallenge,
  handleStopRecording,
  initialPhotoUrl,
  handleShare,
}) => {
  const {width} = useWindowDimensionsSafe();
  console.log_on_production({flash});

  var {
    isVideo = false,
    showPhotoUpload = false,
    onScore,
    onReport,
  } = useParams();

  const handleDone = () => navigationRef.goBack(null);
  // isVideo = 1;
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        position: 'absolute',
        bottom: 20,
        width,
        zIndex: 100,
        height: 90,
        backgroundColor: global?.color?.gray3_50,
      }}>
      {!!showSave && !initialPhotoUrl && (
        <Fragment>
          <CameraIcon
            testID={'savePhoto'}
            handlePress={handleSubmitChallenge}
            name={'save'}
            active={true}
            label={!!onScore ? 'Submit Challenge' : 'Save'}
          />

          <CameraIcon
            handlePress={handleRetake}
            name={'cross'}
            active={true}
            label={'Retake'}
          />
        </Fragment>
      )}
      {!!initialPhotoUrl && (
        <Fragment>
          <CameraIcon
            handlePress={handleShare}
            name={'share'}
            active={true}
            label={'Share Photo'}
          />
          {/* <CameraIcon
            handlePress={() => {
              saveToCameraRoll(initialPhotoUrl, '', 1);
            }}
            name={'save'}
            active={true}
            label={'Save Photo'}
          /> */}
          {!!onReport && (
            <CameraIcon
              handlePress={() => {
                onReport(handleDone);
              }}
              name={'flag'}
              active={true}
              label={'Report Photo'}
            />
          )}
          <CameraIcon
            handlePress={() => {
              navigationRef.goBack(null);
            }}
            name={'cross'}
            active={true}
            label={'Close Photo'}
          />
        </Fragment>
      )}
      {!showSave && (
        <Fragment>
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <CameraIcon
              name={'cross'}
              handlePress={() => navigationRef.goBack()}
              active={true}
              label={'Close'}
            />

            {!!showPhotoUpload && (
              <CameraIcon
                name={'upload'}
                handlePress={handleCameraRoll}
                active={true}
                label={`Cameraroll`}
              />
            )}
          </View>

          <TouchableOpacity
            style={{
              backgroundColor: global?.color?.gray2_50,
              borderRadius: 34,
              width: 68,
              height: 68,
              justifyContent: 'center',
              alignItems: 'center',
            }}
            testID={'takePhoto'}
            activeOpacity={0.8}
            disabled={!!loading}
            onPress={isRecording ? handleStopRecording : handleCapture}>
            {!isRecording && (
              <View
                style={{
                  ...global?.style.boxShadow,
                  backgroundColor: isVideo
                    ? global?.color?.red
                    : global?.color?.white,
                  borderRadius: 26,
                  height: 52,
                  width: 52,
                }}
              />
            )}

            {!!isRecording && (
              <View
                style={{
                  ...global?.style.boxShadow,
                  backgroundColor: global?.color?.red,
                  borderRadius: 6,
                  height: 34,
                  width: 34,
                }}
              />
            )}
          </TouchableOpacity>
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <CameraIcon
              name={'cycle'}
              handlePress={toggleCamera}
              active={reverseState}
              label={
                type === Camera.Constants.Type.back ? 'Back-Cam' : 'Selfie-Cam'
              }
            />
            <CameraIcon
              name={'flash'}
              handlePress={() => {
                console.log_on_production('pressed', {flash});
                toggleFlash();
              }}
              size={20}
              label={flash ? 'Flash On' : 'Flash Off'}
              active={flash}
            />
          </View>
        </Fragment>
      )}
    </View>
  );
};

const CameraIcon = ({
  active,
  name,
  handlePress,
  label,
  size = 24,
  testID = 'cameraControlRow',
}) => {
  const color = active ? global?.color?.white : global?.color?.gray1_80;
  return (
    <TouchableOpacity
      style={{
        minWidth: 60,
        height: 40,

        marginHorizontal: 10,
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
      testID={testID}
      activeOpacity={0.8}
      onPress={() => {
        console.log_on_production('CameraIcon Pressed', {
          name,
          active,
          label,
          handlePress,
        });
        handlePress();
      }}>
      {!!name && (
        <View style={{height: 30}}>
          <EntypoIcon name={name} size={size} color={color} />
        </View>
      )}
      {!!label && (
        <BodyText
          text={label}
          textStyle={{
            color,
            fontSize: 10,
            marginTop: 2,
          }}
        />
      )}
    </TouchableOpacity>
  );
};

export default CameraControlRow;
